import React, { Component } from "react";
import { Row, Col } from "react-bootstrap";
import Pagination from "react-js-pagination";
import { Icon, Dropdown } from "semantic-ui-react";

import OSAllAgenciesCard from "../../OSAgencyCard/OSAllAgenciesCard";
import { translate, getLanguage } from "../../Translation/Translation";

import Input from "../../Input/Input";
import { FETCH_URL } from "../../../utilities";

class AllAgenciesContent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      all: [],
      country: [],
      prefect: [],
      municipal: [],
      agencies: [],
      activeOutPage: 1,
      agenciesToRender: [],
      notFound: false,
    };
    this.handleChangeText = this.handleChangeText.bind(this);
  }

  handleChangeText(event) {
    event.preventDefault(event);
    const { agencies } = this.state;
    if (event.target.value.length > 0) {
      const filteredAgencies = agencies.filter(
        (agency) =>
          agency.name
            .toUpperCase()
            .indexOf(event.target.value.toUpperCase()) !== -1
      );
      if (filteredAgencies.length > 0) {
        this.setState({
          agenciesToRender: filteredAgencies,
          notFound: false,
          activeOutPage: 1,
        });
      } else {
        this.setState({
          agenciesToRender: agencies,
          notFound: true,
          activeOutPage: 1,
        });
      }
    } else {
      this.setState({
        agenciesToRender: agencies,
        notFound: false,
        activeOutPage: 1,
      });
    }
  }

  handlePageChangeOut = (pageNumber) => {
    this.setState({ activeOutPage: pageNumber });
  };

  fetchAgencies = (countryId, perfectureId, municipalityId) => {
    fetch(`${FETCH_URL}/proxy.php?ws=a4b2006416a7e79c658a52a9d7f3b63a`, {
      method: "POST",
      body: JSON.stringify({
        languageCode: `${getLanguage()}`,
        countryId: countryId,
        prefectureId: perfectureId,
        municipalityId: municipalityId,
        online: false,
      }),
    })
      .then((response) => response.json())
      .then((responseJson) => {
        this.setState({
          agencies: responseJson.agencies.reduce(
            (agencies, agency) =>
              agencies.findIndex((obj) => obj.id === agency.id) < 0
                ? [...agencies, agency]
                : agencies,
            []
          ),
        });
      });
  };

  fetchCountries = () => {
    fetch(
      `${FETCH_URL}/proxy.php?ws=00095892afeafcc7f393499c65cd2c4c/${getLanguage()}`,
      {
        method: "GET",
      }
    )
      .then((response) => response.json())
      .then((responseJson) => {
        this.setState({ country: responseJson });
        this.fetchCountryData(88);
        return responseJson;
      })
      .catch((error) => {
        console.error(error);
      });
  };

  fetchCountryData = (countryId) => {
    fetch(
      `${FETCH_URL}/proxy.php?ws=6d2bf7839787aba469120a7df1a99f50/${getLanguage()}/${countryId}`,
      {
        method: "GET",
      }
    )
      .then((response) => response.json())
      .then((responseJson) => {
        this.setState({
          municipal: responseJson.municipalities,
          prefect: responseJson.prefectures,
        });
        return responseJson;
      })
      .catch((error) => {
        console.error(error);
      });
  };

  componentDidMount() {
    this.fetchCountries();
    if (this.props.agencies.countryId) {
      this.fetchAgencies(
        this.props.agencies.countryId,
        this.props.agencies.perfectureId,
        this.props.agencies.municipalityId
      );
    }
  }

  countryChanged = (target) => {
    this.setState({ activeOutPage: 1 });
    this.props.setCountry(target.value);
  };
  perfectureChanged = (target) => {
    this.setState({ activeOutPage: 1 });
    this.props.setPerfecture(target.value);
  };
  municipalityChanged = (target) => {
    this.setState({ activeOutPage: 1 });
    this.props.setMunicipality(target.value);
  };

  componentWillReceiveProps(nextProps) {
    if (this.props.agencies.countryId !== nextProps.agencies.countryId) {
      this.fetchCountryData(nextProps.agencies.countryId);
      this.fetchAgencies(
        nextProps.agencies.countryId,
        nextProps.agencies.perfectureId,
        nextProps.agencies.municipalityId
      );
    } else if (
      this.props.agencies.perfectureId !== nextProps.agencies.perfectureId ||
      this.props.agencies.municipalityId !== nextProps.agencies.municipalityId
    ) {
      this.fetchCountryData(nextProps.agencies.countryId);
      
      this.fetchAgencies(
        nextProps.agencies.countryId,
        nextProps.agencies.perfectureId,
        nextProps.agencies.municipalityId
      );
    }
  }

  render() {
    let country = [];
    country = this.state.country.map((country) => {
      return { key: country.id, text: country.name, value: country.id };
    });

    let prefect = [];
    prefect = this.state.prefect.map((prefect) => {
      return { key: prefect.id, text: prefect.name, value: prefect.id };
    });

    let municipal = [];
    let filteredMunicipalities = this.state.municipal.filter((municipality) => {
      return municipality.parentId == this.props.agencies.perfectureId;
    });

    municipal = filteredMunicipalities.map((municipalities) => {
      return {
        key: municipalities.id,
        text: municipalities.name,
        value: municipalities.id,
      };
    });

    if (filteredMunicipalities.length === 0) {
      municipal = [{ key: -1, text: "No Results", value: -1 }];
    }

    const { agenciesToRender, agencies } = this.state;

    const agenciesSliced = this.state[
      agenciesToRender.length > 0 ? "agenciesToRender" : "agencies"
    ].slice(
      (parseInt(this.state.activeOutPage) - 1) * 10,
      parseInt(this.state.activeOutPage) * 10
    );

    const agenciesMap = agenciesSliced.map((agency) => {
      return (
        <OSAllAgenciesCard
          key={agency.id}
          name={agency.name}
          address={agency.address}
          tel={agency.telephone}
          fax={agency.fax}
          url={agency.webSiteUrl}
          agencyId={agency.id}
          lat={agency.latitude}
          long={agency.longitude}
        />
      );
    });

    const { notFound } = this.state;
    return (
      <div>
        <Row
          style={{
            margin: "20px 0px",
            padding: "0px",
            textAlign: "center",
            background: "white",
            display: "block",
          }}
        >
          <Dropdown
            className="filterDrop"
            style={{
              height: "45px",
              borderRadius: "0",
              margin: "0px 10px 0px 0px ",
              textAlign: "center",
            }}
            placeholder={translate(getLanguage(), "Country")}
            selection
            value={this.props.agencies.countryId}
            options={country}
            onChange={(event, target) => this.countryChanged(target)}
            selectOnBlur={false}
          />
          <Dropdown
            className="filterDrop"
            style={{
              height: "45px",
              borderRadius: "0",
              margin: "0px 10px 0px 0px ",
              textAlign: "center",
            }}
            placeholder={translate(getLanguage(), "Prefecture")}
            selection
            value={this.props.agencies.perfectureId}
            options={prefect}
            onChange={(event, target) => this.perfectureChanged(target)}
            selectOnBlur={false}
          />
          <Dropdown
            className="filterDrop"
            style={{
              height: "45px",
              borderRadius: "0",
              margin: "0px 10px 0px 0px ",
              textAlign: "center",
            }}
            placeholder={translate(getLanguage(), "Municipality")}
            selection
            value={this.props.agencies.municipalityId}
            options={municipal}
            onChange={(event, target) => this.municipalityChanged(target)}
            selectOnBlur={false}
          />
          <Input
            placeholder={translate(getLanguage(), "SearchInput")}
            onChangeText={this.handleChangeText}
          >
            <i aria-hidden="true" className="search icon text-input-icon" />
          </Input>
        </Row>
        <Row style={{ margin: "0px" }}>
          <Row
            style={{
              margin: "0px",
              marginTop: "0px",
              background: "rgb(140,216,248)",
              padding: "10px 0px",
              color: "rgb(40,76,100)",
              fontWeight: "bold",
            }}
          >
            <Col lg={10} md={10} sm={10} xs={10}>
              <Col lg={5} md={5} sm={5} xs={12} style={{ padding: "0px" }}>
                <div className="">
                  {" "}
                  {translate(getLanguage(), "Name")} /{" "}
                  {translate(getLanguage(), "Address")}{" "}
                </div>
              </Col>
              <Col className="removePaddingsOnXS" lg={4} md={4} sm={4} xs={12}>
                <div className=""> {translate(getLanguage(), "Phone")} </div>
              </Col>
              <Col lg={3} md={3} sm={3} xs={12} style={{ padding: "0px" }}>
                <div className=""> {translate(getLanguage(), "Fax")} </div>
              </Col>
            </Col>
            <Col lg={1} md={1} sm={1} xs={1} style={{ padding: "0px" }}>
              <Icon style={{ cursor: "pointer" }} name="globe" size="large" />
            </Col>
            <Col lg={1} md={1} sm={1} xs={1} style={{ padding: "0px" }}>
              <Icon
                style={{ cursor: "pointer" }}
                name="building outline"
                size="large"
              />
            </Col>
          </Row>
          {!notFound ? (
            <div className="AgenciesTable">{agenciesMap}</div>
          ) : (
            <div>
              <h2
                style={{
                  textAlign: "center",
                  paddingTop: 24,
                  paddingBottom: 24,
                }}
              >
                {translate(getLanguage(), "Nothing Found")}
              </h2>
            </div>
          )}
          {!notFound && (
            <div style={{ marginBottom: "20px" }}>
              <Pagination
                activePage={this.state.activeOutPage}
                itemsCountPerPage={10}
                totalItemsCount={
                  agenciesToRender.length > 0
                    ? agenciesToRender.length
                    : agencies.length
                }
                pageRangeDisplayed={5}
                onChange={this.handlePageChangeOut}
              />
            </div>
          )}
        </Row>
      </div>
    );
  }
}

export default AllAgenciesContent;



// WEBPACK FOOTER //
// ./src/components/Pages/Allagencies/AllAgenciesContent.js